import { Component, OnInit } from "@angular/core"

@Component({
  selector: "c1-privacy-card",
  templateUrl: "./card.component.html",
  styleUrls: ["./card.component.scss"],
  standalone: false,
})
export class CardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
